import { getSettings, updateFormStatus } from "@/services/settings.service";

// initial state
const state = () => ({});

// mutations
const mutations = {};

// actions
const actions = {
  //Level Listesi
  async loadSettings(vuexContext, co) {
    return await getSettings(co).then((response) => {
      let data = response.data.data.items;

      if (data.length > 0) {
        return data[0];
      } else {
        return {};
      }
    });
  },
  //Dönem Update
  async updateFormStatus(vuexContext, formStatus) {
    return await updateFormStatus(formStatus);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
